import { useState, useCallback, useEffect } from 'react';
import { api } from '../services/apiClient';

export function useInvoices(tab, toast) {
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [invSeq, setInvSeq] = useState(1);

  const loadInvoices = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api.list({ type: tab });
      setInvoices(data);
      setInvSeq(data.filter(i => i.type === tab).length + 1);
    } catch (e) {
      toast('Failed to load: ' + e.message, 'error');
    } finally {
      setLoading(false);
    }
  }, [tab, toast]);

  useEffect(() => { loadInvoices(); }, [loadInvoices]);

  async function createOrUpdate(activeInv, payload) {
    const isNew = !activeInv?._id;
    const result = isNew ? await api.create(payload) : await api.update(activeInv._id, payload);
    await loadInvoices();
    return result;
  }

  async function remove(id) {
    await api.del(id);
    await loadInvoices();
  }

  return { invoices, loading, invSeq, loadInvoices, createOrUpdate, remove };
}
